class HeaderController extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.attachEvents();
    this.updateHeaderState();
  }

  attachEvents() {
    window.addEventListener('scroll', this.onScrollPage);

    document.addEventListener('AnnouncementBar-before:hide', () => this.ignoreScroll = true);

    document.addEventListener('AnnouncementBar-after:hide', () => this.ignoreScroll = false);

    this.dropdownTriggers.forEach(trigger => {
      const container = trigger.querySelector('[data-dropdown-container]');

      if (!container) {
        return;
      }

      trigger.addEventListener('mouseenter', () => {
        const activeSearchModal = this.querySelector('[data-header-search].is-visible');

        if (activeSearchModal) {
          this.closeSearchModal(activeSearchModal);
        }

        container.classList.add('is-visible');

        bodyScroll.lock(container);
      });

      trigger.addEventListener('mouseleave', () => {
        container.classList.remove('is-visible');

        bodyScroll.unlock(container)
      });
    });

    this.cardTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', this.updateMenuCard.bind(this));
    });

    this.searchTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.toggleSearchModal.bind(this));
    });

    document.addEventListener('click', (event) => {
      const clickedInsideModal = this.searchModal.contains(event.target);
      const clickedOnTrigger = [...this.searchTriggers].some(trigger => trigger.contains(event.target));

      if (!clickedInsideModal && !clickedOnTrigger) {
        this.closeSearchModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeSearchModal();
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollPage);
  }

  init() {
    this.lastScrollPosition = window.scrollY;
    this.onScrollPage = this.onScrollPage.bind(this);
    this.ignoreScroll = false;
    this.dropdownTriggers = this.querySelectorAll('[data-dropdown-trigger]');
    this.cardTriggers = this.querySelectorAll('[data-card-trigger]');
    this.menuCardsSettings = JSON.parse(document.getElementById('menu-cards').textContent);
    this.searchTriggers = this.querySelectorAll('[data-search-trigger]');
    this.searchModal = this.querySelector('[data-header-search]');
  }

  onScrollPage() {
    if (this.scheduled || this.ignoreScroll) {
      return;
    };

    this.scheduled = true;

    requestAnimationFrame(() => {
      this.updateHeaderState();

      this.lastScrollPosition = window.scrollY;
      this.scheduled = false;
    });
  }

  updateHeaderState() {
    this.toggleVisible();
    this.toggleSticky();
  }

  toggleVisible() {
    const activeElements = this.querySelectorAll('[data-dropdown-container].is-visible, [data-header-search].is-visible');

    const isScrollingDown = window.scrollY > this.lastScrollPosition && activeElements.length === 0;

    this.classList.toggle('is-hidden', isScrollingDown);
  }

  toggleSticky() {
    const isSticky = window.scrollY > 0;

    this.classList.toggle('is-sticky', isSticky);
  }

  toggleSearchModal(event) {
    event.preventDefault();

    const isOpen = this.searchModal.classList.contains('is-visible');

    if (isOpen) {

      this.closeSearchModal();

      return;
    }

    this.openSearchModal();
  }

  openSearchModal() {
    const searchField = this.searchModal.querySelector('input[type="search"]');

    this.searchModal.classList.add('is-visible');

    bodyScroll.lock(this.searchModal);

    this.searchModal.addEventListener('transitionend', () => {
      searchField?.focus();

      trapFocus(this.searchModal);
    },{ once: true });
  }

  closeSearchModal() {
    this.searchModal.classList.remove('is-visible');

    removeTrapFocus(this.searchModal);

    bodyScroll.unlock(this.searchModal);
  }

  updateMenuCard(event) {
    const trigger = event.currentTarget;
    const linkTitle = trigger.textContent.trim();
    const targetCardSettings = this.menuCardsSettings.find(cardSetting => cardSetting.link === linkTitle);
    const dropdownContainer = trigger.closest('[data-dropdown-container]');
    const targetCard = dropdownContainer?.querySelector('[data-card]');

    if (!targetCard || !targetCardSettings) {
      return;
    }

    targetCard.querySelectorAll('[data-card-url]').forEach(cardUrl => cardUrl.href = targetCardSettings.url);

    targetCard.querySelectorAll('[data-card-title]').forEach(cardTitle => {
      const hasTitle = targetCardSettings.label !== '';

      cardTitle.classList.toggle('hidden', !hasTitle);

      if (!hasTitle) {
        return;
      }

      cardTitle.textContent = targetCardSettings.label;
    });

    const cardImage = targetCard.querySelector('[data-card-image]');

    if (cardImage && cardImage.src !== targetCardSettings.image) {
      const tempImage = new Image();

      tempImage.onload = () => {
        cardImage.src = targetCardSettings.image;
      };

      tempImage.src = targetCardSettings.image;
    }
  }
}

customElements.define('header-controller', HeaderController);
